import './article-header.scss';
import ArticleHeader from './article-header';

const articleHeaderConfig = {
  name: 'articleHeader',
  class: ArticleHeader,
  querySelector: {
    content: '.article-header',
  },
  querySelectorAll: {
    slideshowBlock: '.wp-block-jetpack-slideshow',
    galleryBlock: '.wp-block-gallery',
  },
  options: {
    slideshowCaptionClass: '.wp-block-jetpack-slideshow_caption',
    galleryCaptionClass: '.blocks-gallery-item__caption',
  },
};

export default articleHeaderConfig;
